import React, { useState } from "react";
import { useAuth } from "../../../context/AuthContext";
import CareerForm from "../forms/CareerForm";
import {
  FaFileAlt,
  FaEye,
  FaDownload,
  FaCheckCircle,
  FaClock,
  FaTimesCircle,
} from "react-icons/fa";

const CareerSection = () => {
  const { user, updateUser } = useAuth();
  const [isEditing, setIsEditing] = useState(false);

  const isInstitution = user?.role === "institution";

  const degree = user?.degree === "other" ? user?.degreeOther : user?.degree;

  const field =
    user?.fieldOfStudy === "other"
      ? user?.fieldOfStudyOther
      : user?.fieldOfStudy;

  const getStatus = () => {
    const status = user?.userApprovalStatus || "pending"; // from backend

    switch (status) {
      case "approved":
        return {
          label: "Approved",
          className: "status approved",
          icon: <FaCheckCircle />,
        };

      case "pending":
        return {
          label: "Pending",
          className: "status pending",
          icon: <FaClock />,
        };

      case "rejected":
        return {
          label: "Rejected",
          className: "status rejected",
          icon: <FaTimesCircle />,
        };

      default:
        return {
          label: "Unknown",
          className: "status",
          icon: null,
        };
    }
  };

  const status = getStatus();

  // const TutorCareerView = ({ user }) => {
  //   const degree = user?.degree === "other" ? user?.degreeOther : user?.degree;

  //   const field =
  //     user?.fieldOfStudy === "other"
  //       ? user?.fieldOfStudyOther
  //       : user?.fieldOfStudy;

  //   return user?.schoolName || degree || field ? (
  //     <div className="program-card">
  //       <div className="program-row">
  //         <span className="program-icon">🏫</span>

  //         <div>
  //           <p className="program-title">
  //             {user?.schoolName || "No School Added"}
  //           </p>

  //           <p className="program-sub">
  //             {degree || "No Degree"} • {field || "No Field"}
  //           </p>
  //         </div>
  //       </div>
  //     </div>
  //   ) : (
  //     <p>No program data added</p>
  //   );
  // };

  const TutorCareerView = ({ user }) => {
  const degree = user?.degree === "other" ? user?.degreeOther : user?.degree;
  const field = user?.fieldOfStudy === "other" ? user?.fieldOfStudyOther : user?.fieldOfStudy;

  return (
    <div className="program-card">
      <div className="program-row">
        <span className="program-icon">🏫</span>
        <div>
          <p className="program-title">{user?.schoolName || "No School Added"}</p>
          <p className="program-sub">
            {degree || "No Degree"} • {field || "No Field of Study"}
          </p>
        </div>
      </div>
    </div>
  );
};


  return (
    <div className="career-profile-card">
      <div className="account-profile-header">
        <h3>{isInstitution ? "Training Center Credentials" : "Credentials"}</h3>

        {!isEditing && !isInstitution && (
          <button className="edit-btn" onClick={() => setIsEditing(true)}>
            ✏️ Edit
          </button>
        )}
      </div>

      {!isEditing ? (
        <div className="program-view">
          {/* 🏫 INSTITUTION */}
          {isInstitution ? (
            user?.documents?.length ? (
              user.documents.map((doc, index) => {
                const status = getStatus(doc.status);

                return (
                  <div key={index} className="doc-card">
                    <div className="doc-left">
                      <FaFileAlt className="doc-icon" />

                      <div>
                        <p className="doc-title">{doc.name}</p>
                        <p className="doc-date">
                          Uploaded on{" "}
                          {new Date(doc.createdAt).toLocaleDateString()}
                        </p>
                      </div>
                    </div>

                    <div className="doc-right">
                      <div className={status.className}>
                        {status.icon} {status.label}
                      </div>

                      <div className="doc-actions">
                        <a href={doc.fileUrl} target="_blank" rel="noreferrer">
                          <FaEye />
                        </a>

                        <a href={doc.fileUrl} download>
                          <FaDownload />
                        </a>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <p>No documents uploaded</p>
            )
          ) : (
            <TutorCareerView user={user} />
          )}
        </div>
      ) : (
        <CareerForm onCancel={() => setIsEditing(false)} />
      )}
    </div>
  );
};

export default CareerSection;
